var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJindal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 593.3 316",
    style: {
      enableBackground: "new 0 0 593.3 316"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#58AB40;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#F58220;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#F7F7F7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.5,125.1c-10.7,27.8,6.1,14.3,60.4-17.3c49.5-28.7,80.8-50.2,96.2-79.4c2.2,47.6-22.9,74.3-112.2,129.2 c-53.8,33.1-72.8,40.1-67.2,19.6c3.2-11.7,5.9-19.7,8.4-26.9c-0.1,0.4,0.2-0.4,0,0C376.5,137.1,379.2,133.1,383.5,125.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.8,88.7c9-2.9,21.1-5.7,33-8.4c33.2-7.4,21.8,18.2,8.5,45.3c-4.1,8.4-6.8,11.5-14.1,24.7 c5.2-16.2,11.3-25.3-0.7-23.3c-12.4,2-25.9,5.9-36.7,9.3L341.8,88.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.2,228.5c-3.5-1.4-7.2-2.2-10.9-2.2c-7.5,0-15,4.7-15,13c0,12.6,15.5,11,15.5,20.3c0,3.8-2.9,8.1-9.8,8.1 c-3.2,0-6.9-1.2-9.6-2.9l-2.1,6c3.7,1.4,7.4,2.6,12.7,2.6c10.9,0,15.7-7.8,15.7-14.6c0-11.9-15.5-12-15.5-19.6c0-5.4,4.7-7.1,9-7.1 c3.5,0,6.1,0.9,8.3,2.2L129.2,228.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "169.4,227.1 134.6,227.1 133.4,232.9 147.5,232.9 139,272.6 145.5,272.6 154.1,232.9 168.2,232.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "166,272.6 191.7,272.6 192.9,266.9 173.9,266.9 177.2,251.9 194.2,251.9 195.4,246.1 178.5,246.1  181.4,232.9 199.4,232.9 200.7,227.1 176,227.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "202,272.6 227.6,272.6 228.9,266.9 209.8,266.9 213.1,251.9 230.2,251.9 231.3,246.1 214.4,246.1  217.3,232.9 235.3,232.9 236.6,227.1 211.9,227.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "237.6,272.6 263.2,272.6 264.3,266.9 245.5,266.9 254.1,227.1 247.5,227.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M302.8,249.5c6.2-2.3,12.8-5.5,12.8-13.1c0-7.2-5.9-10-12.2-10c-6,0-12.6,4.1-12.6,10.8c0,3.8,1.2,6.8,3.5,9.8 c-6.6,1.5-13,6-13,13.6c0,8.2,5.9,12.8,15.5,12.8c4.4,0,8.9-1.7,12-4.2l2.2,3.5h7.2l-5-7.6c5-4.6,7-10.7,8.1-17h-5.8 c-0.9,4.3-2.3,8.7-5.5,12.2L302.8,249.5z M305.7,264.6c-3.2,2.8-6.8,3.8-9.3,3.8c-4.7,0-8.7-3.1-8.7-8.1c0-5.4,5-7.8,9.3-8.9 L305.7,264.6z M299.9,245.2c-1.6-2.2-3.1-4.5-3.1-7.4c0-4.2,3.1-6.6,6.8-6.6c3.4,0,6.3,1.6,6.3,5.5 C309.9,241.6,303.8,244.2,299.9,245.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.8,272.6h6.5l4-18.2h6.5c12.2,0,18.8-6.4,18.8-15.4c0-9.1-7.8-11.9-14.6-11.9h-11.3L343.8,272.6z  M359,232.9h3.4c5.5,0,10.3,0.8,10.3,7.1c0,7.4-7,8.7-13.7,8.7h-3.5L359,232.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M382,254.1c0,12.6,6.6,19.3,19.1,19.3c16.5,0,25-14.2,25-28.6c0-11.6-6.8-18.4-18.4-18.4 C391,226.3,382,241.2,382,254.1 M388.9,254.3c0-11.6,7.4-22.2,18.6-22.2c7.8,0,11.7,4.9,11.7,13.6c0,9.9-6.6,22-17.8,22 C393.2,267.6,388.9,262.4,388.9,254.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "436.9,272.6 445.5,272.6 463.6,233.2 463.8,233.2 464.7,272.6 473.2,272.6 497,227.1 490,227.1  470.4,266.1 470.2,266.1 469.1,227.1 460.4,227.1 442.3,266 442.2,266 439.7,227.1 433.2,227.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "493.5,272.6 519.2,272.6 520.4,266.9 501.4,266.9 504.7,251.9 521.7,251.9 522.8,246.1 506,246.1  508.9,232.9 526.9,232.9 528.2,227.1 503.5,227.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M529.5,272.6h6.5l4.2-20.2h5.8c3.4,0,4.5,1,6.2,8.3l2.7,11.9h6.9l-2.5-9.6c-0.9-3.5-1.9-10.4-5.3-12.5 c6.1-0.9,11.1-6.1,11.1-12.3c0-11.1-10.6-11.1-17-11.1h-8.9L529.5,272.6z M544.5,232.9h6.1c5,0,7.7,1.5,7.7,6.3 c0,6.1-6.9,7.6-11.5,7.6h-5.1L544.5,232.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "114,210 125.8,153.6 141.1,153.6 164.6,184.1 165,184.1 171.4,153.6 188.3,153.6 176.4,210 160.5,210  137.3,180.3 137.1,180.3 130.8,210  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M186.8,210l11.8-56.4h29.8c18.5,0,28,11.5,24.2,29.7c-4.3,20.6-19.3,26.7-39.8,26.7H186.8z M215.3,166.2 l-6.6,31.1h3.1c13-0.2,18.6-3.8,21-15.3c2.5-12-2.8-15.8-14.5-15.8L215.3,166.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "244,210 281.8,153.6 302.6,153.6 312.8,210 291.4,210 286.5,175.6 286.3,175.5 264.9,210  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "316,210 327.9,153.6 347.3,153.6 338,197.3 360.7,197.3 358.1,210  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "84.3,210 96.2,153.6 115.5,153.6 103.6,210  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "244,210 281.8,153.6 302.6,153.6 312.8,210 291.4,210 286.5,175.6 286.3,175.5 264.9,210  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.6,205.4c28,6,30.1-9.4,31.9-16.9C58.3,181,67,139.6,67,139.6h21.8c0,0-5.8,27.4-11,52.2 c-3.8,17.3-17,30.3-40.4,28.7c-6.9-0.5-12.6-2.8-15.3-4.9c0,0-1.6-1.1-1.8-1.3L23,205C23.2,205.1,24.2,205.3,24.6,205.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJindal);
export default __webpack_public_path__ + "static/media/jindal.ee63b714a4ae4d422205328b6eec9fdd.svg";
export { ForwardRef as ReactComponent };